YP.ExhibitAccountManager = function() {
    var form                 = $('.c-form_js-exhibit-contact');
    var addContactChoiceCont = form.find('.c-form__js-add-contact-choice');
    var fileUploadCont       = form.find('.c-form__js-contact-csv');
    var jsonContactCont      = form.find('.c-form__js-json-contact');

    return {
        
        initContactForm: function() {
            var klass                = this;

            jsonContactCont.hide();
            fileUploadCont.hide();
            klass.displayContactFormChoices(addContactChoiceCont.find('input[type=radio]').val());

            addContactChoiceCont.find('input[type=radio]').change(function() {
                klass.displayContactFormChoices($(this).val());
            });
            addContactChoiceCont.find('input[type=radio]:checked').trigger('change');
        },
        displayContactFormChoices: function(value) {
            if (value == 0) {
                jsonContactCont.show();
                fileUploadCont.hide();
            }
            if (value == 1) {
                jsonContactCont.hide();
                fileUploadCont.show();
            }
        }
    };
};
window.addEventListener("load", function() {
    if ($('.c-form_js-exhibit-contact').length) {
        YP.ExhibitAccountManager().initContactForm();
    }
});
